module.exports = __webpack_public_path__ + "img/drum.8c1355a9.gif";